// Centralized API configuration
// This file provides a single source of truth for the API base URL

// In production, REACT_APP_API_URL and REACT_APP_API_BASE_URL are set via .env.production
// In development (npm start), they come from .env which points to localhost:4000/dev

export const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/dev';

// WebSocket URL for real-time push notifications
export const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:4001';

// Claude the Explorer lives in its own Serverless service (justsomeguy-explorer-backend)
// because the main backend hit the CFN 500-resource cap. This URL points at that
// separate API Gateway. Set REACT_APP_EXPLORER_API_URL in .env to override per stage.
export const EXPLORER_API_BASE_URL = process.env.REACT_APP_EXPLORER_API_URL
  || 'https://9hzkqctqlf.execute-api.us-east-1.amazonaws.com/dev';

// Viewer-chat base — currently the same gateway as EXPLORER_API_BASE_URL, but
// exported separately so it can move (e.g., dedicated chat endpoint in a later
// iteration) without churning every callsite. Override via env per stage.
export const EXPLORER_CHAT_BASE_URL = process.env.REACT_APP_EXPLORER_CHAT_URL
  || EXPLORER_API_BASE_URL;

// S3 media base URL for production assets
export const S3_MEDIA_BASE_URL = 'https://spaceexplorer-content-files.s3.us-east-1.amazonaws.com';

// Helper to convert localhost URLs to S3 URLs in production
export const convertToProductionUrl = (url) => {
  if (!url) return url;

  // If already an S3 URL or HTTPS URL, return as-is
  if (url.startsWith('https://')) return url;

  // Replace localhost URLs with S3 URLs
  const localPatterns = [
    'http://localhost:4000/dev/media/',
    'http://localhost:4000/media/',
  ];

  for (const pattern of localPatterns) {
    if (url.includes(pattern)) {
      return url.replace(pattern, S3_MEDIA_BASE_URL + '/');
    }
  }

  return url;
};

// Log the current configuration for debugging (dev builds only)
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  console.log('[API Config] API_BASE_URL:', API_BASE_URL);
  console.log('[API Config] Environment:', process.env.NODE_ENV);
}
